export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div>© {new Date().getFullYear()} 미손소리</div>
        <div>판소리 × 국문학 · 교육 · 공연 · 연구</div>
      </div>
    </footer>
  );
} 